import { createReducer, on } from "@ngrx/store";
import { AuthUser } from "./models/auth-user.model";
import { AuthSite } from "./models/auth-logspace-locator.model";
import { AuthActions } from "./auth.actions";
import { AuthPermissionList } from "./models/auth-permissions.model";

export interface AuthState {
  user: AuthUser | null;
  site: AuthSite | null;
  availableSites: AuthSite[];
  permissions: AuthPermissionList | null;
  isLoading: boolean;
  error: string | null;
}

export const initialAuthState: AuthState = {
  user: null,
  site: null,
  availableSites: [],
  permissions: null,
  isLoading: false,
  error: null,
};

export const authReducer = createReducer(
  initialAuthState,
  on(AuthActions.login, (state, action) => {
    return {
      ...state,
      error: null,
    };
  }),
  on(AuthActions.loginSuccess, (state, action) => {
    return {
      ...state,
      user: action.user,
      site: action.site || null,
      availableSites: action.siteList,
      permissions: null,
      isLoading: false,
      error: null,
    };
  }),
  on(AuthActions.loginFailure, (state, action) => {
    const errorMessage =
      action.error?.message || "Login failed. Please check your credentials.";
    return {
      ...state,
      user: null,
      site: null,
      permissions: null,
      isLoading: false,
      error: errorMessage,
    };
  }),
  on(AuthActions.logoutSuccess, (state, action) => {
    return {
      ...state,
      user: null,
      site: null,
      permissions: null,
    };
  }),
  on(AuthActions.loadCurrentUserSuccess, (state, action) => {
    return {
      ...state,
      user: action.user,
      site: action.site,
      availableSites: action.siteList ?? [],
    };
  }),
  on(AuthActions.loadCurrentUserFailure, (state, action) => {
    return {
      ...state,
      user: null,
      site: null,
      permissions: null,
    };
  }),
  on(AuthActions.updateSiteSuccess, (state, action) => {
    return {
      ...state,
      site: action.newSite,
      permissions: action.permissions,
      error: null,
    };
  }),
  on(AuthActions.updateSiteFailure, (state, action) => {
    return {
      ...state,
      site: null,
      permissions: null,
    };
  }),
  on(AuthActions.refreshPermissionsSuccess, (state, action) => ({
    ...state,
    permissions: action.permissions,
  })),
);
